/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectedServiceDetailDto } from '../../models/collected-service-detail-dto';

export interface ApiCollectedServiceIdGet$Json$Params {
  id: number;
}

export function apiCollectedServiceIdGet$Json(http: HttpClient, rootUrl: string, params: ApiCollectedServiceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectedServiceDetailDto>> {
  const rb = new RequestBuilder(rootUrl, apiCollectedServiceIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CollectedServiceDetailDto>;
    })
  );
}

apiCollectedServiceIdGet$Json.PATH = '/api/CollectedService/{id}';
